import { PlaybackOverride } from '@optools/services/operator-gateway/overrides/playback/types';
import { ClientType } from '@optools/services/operator-gateway/overrides/types';
import {
  PlaybackExperience,
  PlaybackFeature,
  PlaybackOverridesQuery,
} from '@optools/services/operator-gateway/types/generated/graphql';

export function transformPlaybackOverride(
  override: PlaybackOverridesQuery['playbackOverrides'][number],
): PlaybackOverride {
  const { experience, features, id, matchParams } = override;
  const { clientType = ClientType.ALL_CLIENTS, userId = '' } = matchParams;
  return {
    clientType,
    experience: experience as PlaybackExperience,
    features: features as PlaybackFeature[],
    id,
    userId,
  };
}
